<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          @click="handleStep('HOSPEDAGEM')"
          :class="[
            'nav-link link-nav-resident',
            step == 'HOSPEDAGEM' && 'active',
          ]"
          id="nav-hospedagem"
          data-toggle="tab"
          href="#hospedagem"
          role="tab"
          aria-controls="hospedagem"
          aria-selected="true"
          >HOSPEDAGEM</a
        >
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="step == 'HOSPEDAGEM'"
        :class="['tab-pane fade', step == 'HOSPEDAGEM' && 'show active']"
        id="hospedagem"
        role="tabpanel"
        aria-labelledby="nav-hospedagem"
      >
        <hosting :resident="resident" />
      </div>
    </div>
  </div>
</template>

<script>
import Hosting from "./hosting/hosting.vue";

import routes from "../../../routes";

export default {
  name: "MenuHosting",

  components: {
    Hosting,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      step: "HOSPEDAGEM",
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    handleStep(step) {
      let newNav;

      if (step == "HOSPEDAGEM") {
        newNav = "hosting";
      }

      let { tab, nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { tab, nav: newNav } });
      }

      this.step = step;
    },
    async retrieve() {
      const { nav } = routes.history.current.query;

      if (nav) {
        if (nav == "hosting") {
          this.step = "HOSPEDAGEM";
        }
      }
    },
  },
};
</script>